import script from "./UploadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImage.vue?vue&type=script&setup=true&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=52924597&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52924597"]])

export default __exports__